export default __webpack_public_path__ + "static/media/design-icon.17a17cad.svg";